export enum AttachmentOwnerType {
    none = 0,
    ticket = 1,
    reply = 2,
    note = 3,
    replyTemplate = 4,
}
